import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-hand-point-left" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]

import { withDefaults } from "vue";
import { useRouter } from "vue-router";
interface Prop {
  additionalClass: any;
  routeBefore: () => void;
  onClickDelegate: ()=>void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ReturnButton',
  props: {
    additionalClass: { default: { "btn-outline-dark": true } },
    routeBefore: { type: Function, default: () => {
    return;
  } },
    onClickDelegate: { type: Function, default: null }
  },
  setup(__props: any) {

const props = __props as { additionalClass: any, routeBefore: () => void, onClickDelegate: ()=>void };


const router = useRouter();
const onReturn = () => {
  if(props.onClickDelegate){
    props.routeBefore();
    props.onClickDelegate()
  }else{
    props.routeBefore();
    router.back();
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass(["btn mx-1", __props.additionalClass]),
    onClick: onReturn
  }, _hoisted_2, 2))
}
}

})